module.exports = __webpack_public_path__ + "media/images/worldLow-c8012384c4950bb0e3f73e1e12a85784.svg";